import React from "react";
import Event from "@mui/icons-material/Event";
import Schedule from "@mui/icons-material/Schedule";
import { format, parse } from "date-fns";
import {
    BASIC_TIME_FORMAT,
    LONG_TIME_FORMAT,
} from "repoV2/features/Common/modules/DateTime/modules/Time/Time.constants";
import { IWorkshopSession } from "../../WorkshopSessions.interfaces";
import styles from "./SingleSession.module.scss";
import { useSingleSession } from "./SingleSession.utils";

const SingleSession = ({ sessions }: { sessions: IWorkshopSession[] }) => {
    const [session] = sessions;
    useSingleSession({
        session,
    });

    return (
        <div className={styles.Wrapper}>
            {session.startDate && (
                <div className={styles.DateWrapper}>
                    <Event className={styles.EventIcon} />
                    <div className={styles.Date}>{session.startDate}</div>
                </div>
            )}
            {session.startTime && session.endTime && (
                <div className={styles.TimeWrapper}>
                    <Schedule className={styles.ScheduleIcon} />
                    <div className={styles.Time}>{`${format(
                        parse(session.startTime, BASIC_TIME_FORMAT, new Date()),
                        LONG_TIME_FORMAT
                    )} - ${format(
                        parse(session.endTime, BASIC_TIME_FORMAT, new Date()),
                        LONG_TIME_FORMAT
                    )}`}</div>
                </div>
            )}
        </div>
    );
};

export default SingleSession;
